<template>
<div class="graph-div">
    <la-cartesian :autoresize="true" :width="600" :bound="[0]" :data="graphData">
        <defs>
            <linearGradient id="color-id" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stop-color="#2c3e50"></stop>
                <stop offset="0.5" stop-color="#42b983"></stop>
                <stop offset="1" stop-color="#6fa8dc"></stop>
            </linearGradient>
        </defs>
        <la-line :width="2" dashed dot animated curve prop="valuation" label="Valuation"></la-line>
        <la-x-axis :format="formatDate" prop="date"></la-x-axis>
        <la-y-axis :format="formatValuation" prop="valuation"></la-y-axis>
        <la-tooltip>
            <div class="laue_tooltip p-2" slot-scope="props">
                <div class="title p-1">{{ props.label | date }}</div>
                <div class="p-1" :key="item.shares_id" v-for="item in props.actived">
                    <div class="label">{{item.label}}</div>
                    <div class="value">${{(numberWithCommas(item.value))}}</div>
                </div>
            </div>
        </la-tooltip>
    </la-cartesian>
</div>
</template>

<script>
import Utility from "@/../submodules/vue-base/mixins/Utility";
import {
    format,
    parse
} from 'date-fns';
import {
    mapGetters
} from 'vuex';
import {
    Cartesian,
    Line
} from 'laue'
export default {

    name: "KolkinSharesGraph",

    components: {
        LaCartesian: Cartesian,
        LaLine: Line
    },

    mixins: [
        Utility
    ],

    methods: {
        formatValuation(value) {
            if (value == 0) {
                return "";
            }
            var result = value.toPrecision(2) / 1000000;
            result += "M";
            return result;
        },
        formatDate(value) {
            var d = parse(value, 'yyyy-MM-dd', new Date());
            return format(d, 'MM/yyyy');
        }
    },

    computed: {
        graphData() {
            var result = this.dayOfSharesData;
            for (var i = 0; i < result.length; i++) {

                

                var d = parse(result[i]["date"], 'yyyy-MM-dd', new Date());
                result[i]["formatted_date"] = format(d, 'MM/dd/yy');
            }
            return result;
        },

        ...mapGetters(["dayOfSharesData"])
    }

}
</script>

<style lang="less" scoped>
.laue_tooltip {
    background: rgba(0, 0, 0, 0.8);
    border-radius: 4px;
}

.title {
    padding: 10px;
    color: #959da5;
}

.list {
    list-style: none;
    display: flex;
}

.list li {
    padding: 5px 10px;
    flex: 1;
    color: #fff;
    margin: 0;
    min-width: 90px;
}

.list li::before {
    content: none;
}

.label {
    color: #dfe2e5;
    font-weight: 600;
}

.value {
    color: #959da5;
}
</style>
